import React, { createElement, forwardRef } from 'react'
import {
  FormControl,
  FormLabel,
  FormHelperText,
  FormErrorMessage,
  Input,
  Textarea,
  Box,
  InputGroup,
  InputLeftAddon,
} from "@chakra-ui/react"

import Select from './Select'
import DateRange from './DateRange'
import RadioInput from './RadioInput'
import CheckboxInput from './CheckboxInput'

const CleanInput = forwardRef(({ control, rules, ...props }, ref) => <Input {...props} ref={ref} />)
const CleanTextarea = forwardRef(({ control, rules, ...props }, ref) => <Textarea {...props} ref={ref} />)

const types = {
  radio: RadioInput,
  checkbox: CheckboxInput,
  select: Select,
  textarea: CleanTextarea,
  'date-range': DateRange,
}

const FormField = forwardRef(({
  id,
  name,
  options,
  type,
  label,
  helper,
  placeholder,
  rules,
  errors = {},
  leftAddon,
  fieldState,
  when,
  ...props
}, ref) => {
  return (
    <FormControl name={name} id={id} isInvalid={!!errors[name]} isRequired={rules?.required}>
      {label && <FormLabel fontSize="1em">{label}</FormLabel>}
      {helper && <FormHelperText fontSize="0.875em" fontWeight="400" mt="0" mb="3">{helper}</FormHelperText>}
      <InputGroup>
        {leftAddon && <InputLeftAddon>{leftAddon}</InputLeftAddon>}
        {createElement(types[type] || CleanInput, {
          ref,
          type: types[type] ? undefined : type,
          placeholder: placeholder || label,
          name,
          rules,
          ...props
        }, options)}
      </InputGroup >
      <FormErrorMessage>{errors[name]?.message}</FormErrorMessage>
    </FormControl>
  )
})

FormField.displayName = 'FormField'

export default FormField
